const ALLOWED_TYPES =
  'UserNotification,UserModalNotification,FreebetsReward,RewardForfeited,DataSolutionsNotification,ReachedMilestone,ReachedTier';

export default ALLOWED_TYPES;
